export default "__VITE_ASSET__xquDMqjV__"